import React, { useState } from 'react';
import { TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';
import GenericFormModal from './GenericFormModal';

interface AddColumnModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (columnName: string) => void;
}

const AddColumnModal: React.FC<AddColumnModalProps> = ({
  open,
  onClose,
  onAdd,
}) => {
  const [columnName, setColumnName] = useState('');
  const [isDate, setIsDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [dateError, setDateError] = useState<string | null>(null);

  const handleSubmit = () => {
    if (isDate && selectedDate) {
      onAdd(selectedDate.format('DD-MM-YYYY'));
    } else {
      onAdd(columnName);
    }
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setColumnName('');
    setSelectedDate(null);
    setDateError(null);
  };

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);
    if (newValue === null) {
      setDateError('Please select a date');
    } else if (!newValue.isValid()) {
      setDateError('Invalid date format');
    } else {
      setDateError(null);
    }
  };

  const isSubmitDisabled = isDate ? !selectedDate || !!dateError : !columnName;

  return (
    <GenericFormModal
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Add New Column"
      submitText="Add"
      submitDisabled={isSubmitDisabled}
    >
      <RadioGroup
        value={isDate ? 'date' : 'label'}
        onChange={e => {
          setIsDate(e.target.value === 'date');
          setDateError(null);
        }}
        sx={{ mb: 3 }}
      >
        <FormControlLabel value="label" control={<Radio />} label="Label" />
        <FormControlLabel value="date" control={<Radio />} label="Date" />
      </RadioGroup>
      {isDate ? (
        <DatePicker
          label="Select Date"
          value={selectedDate}
          onChange={handleDateChange}
          sx={{ width: '250px' }}
          slotProps={{
            textField: {
              error: !!dateError,
              helperText: dateError || ' ',
            },
          }}
        />
      ) : (
        <TextField
          label="Column Label"
          value={columnName}
          onChange={e => setColumnName(e.target.value)}
          sx={{ width: '250px' }}
        />
      )}
    </GenericFormModal>
  );
};

export default AddColumnModal;
